module.exports = __webpack_public_path__ + "img/report-icon-5.a4fca1ae.png";